import { render, staticRenderFns } from "./DispositivosPantalla.vue?vue&type=template&id=5494ad55&"
import script from "./DispositivosPantalla.vue?vue&type=script&lang=ts&"
export * from "./DispositivosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports